import { render, staticRenderFns } from "./BrowserAgentChatMessages.vue?vue&type=template&id=aed6e3e8&scoped=true"
import script from "./BrowserAgentChatMessages.vue?vue&type=script&lang=js"
export * from "./BrowserAgentChatMessages.vue?vue&type=script&lang=js"
import style0 from "./BrowserAgentChatMessages.vue?vue&type=style&index=0&id=aed6e3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed6e3e8",
  null
  
)

export default component.exports